export const BASE_ROUTES = {
  PPF: "/ppf",
  MENU_LABEL: "/ml",
}
